import React from 'react';

const img = "/images/assets/a68d1f01b37b060c552bf7088357f48dfd8f7f7d.png";

function Frame49() {
  return (
    <div className="content-stretch flex flex-col gap-2 items-start relative shrink-0 w-full">
      <p className="font-['Roboto:Medium',sans-serif] font-medium leading-tight text-3xl sm:text-4xl md:text-[40px] lg:text-[48px] relative shrink-0 text-white w-full" style={{ fontVariationSettings: "'wdth' 100" }}>
        <span>{`Why Choose `}</span>HyreLancer?
      </p>
    </div>
  );
}

function Frame6() {
  return (
    <div className="relative shrink-0 w-full py-3 sm:py-4 md:py-6">
      <div className="flex flex-row items-center size-full">
        <div className="box-border content-center flex flex-wrap items-center justify-center md:justify-start px-4 sm:px-6 md:px-12 lg:px-16 xl:px-32 relative w-full">
          <Frame49 />
        </div>
      </div>
    </div>
  );
}

const featureCards = [
  {
    title: "For Everyone",
    description: "Hire professionals for business, personal, or creative needs — all in one place."
  },
  {
    title: "Access to Skilled Experts",
    description: "Discover verified freelancers across multiple categories and service areas."
  },
  {
    title: "Flexible Hiring",
    description: "Hire for one-time projects, short-term gigs, or long-term partnerships."
  },
  {
    title: "Direct Communication",
    description: "Connect and chat directly with freelancers to finalize details and start right away."
  },
  {
    title: "No Hidden Charges",
    description: "HyreLancer does not process payments. You pay your freelancer directly on mutually agreed terms — with no platform commissions or fees."
  },
  {
    title: "Quick & Seamless Experience",
    description: "From posting your requirement to hiring the perfect professional, the process is smooth and fast."
  }
];

function FeatureCard({ title, description }) {
  return (
    <div className="backdrop-blur-[14.1px] backdrop-filter bg-[rgba(255,255,255,0.25)] h-[180px] sm:h-[160px] md:h-[220px] lg:h-[220px] xl:h-[300px] 2xl:h-[320px] relative rounded-xl sm:rounded-2xl md:rounded-[16px] shrink-0 w-[calc(50%-8px)] sm:w-[calc(50%-12px)] md:w-[calc(33.333%-16px)] lg:w-[calc(33.333%-16px)] xl:w-[calc(16.666%-26.67px)] 2xl:w-[calc(16.666%-26.67px)]">
      <div className="box-border content-stretch flex h-full items-center overflow-clip p-3 sm:p-3.5 md:p-4 lg:p-5 xl:p-5 2xl:p-6 relative rounded-[inherit] w-full">
        <div className="basis-0 content-stretch flex flex-col gap-4 sm:gap-5 md:gap-6 lg:gap-6 xl:gap-7 2xl:gap-8 grow h-full items-start min-h-px min-w-px relative shrink-0">
          <div className="h-[30px] sm:h-[35px] md:h-[40px] lg:h-[45px] xl:h-[50px] 2xl:h-[56px] relative shrink-0 w-[28px] sm:w-[33px] md:w-[38px] lg:w-[43px] xl:w-[48px] 2xl:w-[53px]" data-name="hyrelancer3-01 1">
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
              <img alt="" className="absolute h-[124.66%] left-[-30%] max-w-none top-[-24.66%] w-[130%]" src={img} />
            </div>
          </div>
          <div className="content-stretch flex flex-col gap-1 sm:gap-1.5 md:gap-2 lg:gap-2.5 xl:gap-3 2xl:gap-4 items-start leading-[16px] sm:leading-[18px] md:leading-5 lg:leading-6 relative shrink-0 text-white w-full">
            {title.includes('\n') ? (
              <div className="font-['Roboto:SemiBold',sans-serif] font-semibold relative shrink-0 text-[13px] sm:text-sm md:text-[15px] lg:text-base xl:text-[19px] 2xl:text-[22px] w-full" style={{ fontVariationSettings: "'wdth' 100" }}>
                {title.split('\n').map((line, i) => (
                  <p key={i} className={i === 0 ? "mb-0" : ""}>{line}</p>
                ))}
              </div>
            ) : (
              <p className="font-['Roboto:SemiBold',sans-serif] font-semibold relative shrink-0 text-[13px] sm:text-sm md:text-[15px] lg:text-base xl:text-[19px] 2xl:text-[22px] w-full" style={{ fontVariationSettings: "'wdth' 100" }}>
                {title}
              </p>
            )}
            <p className="font-['Roboto:Regular',sans-serif] font-normal relative shrink-0 text-[9px] sm:text-[10px] md:text-[10.5px] lg:text-[11px] xl:text-xs 2xl:text-[13.5px] w-full" style={{ fontVariationSettings: "'wdth' 100" }}>
              {description}
            </p>
          </div>
        </div>
      </div>
      <div aria-hidden="true" className="absolute border border-[rgba(255,255,255,0.56)] border-solid inset-0 pointer-events-none rounded-xl sm:rounded-2xl md:rounded-[16px]" />
    </div>
  );
}

function Frame71() {
  return (
    <div className="content-stretch flex flex-wrap items-stretch justify-center gap-4 sm:gap-6 md:gap-6 lg:gap-6 xl:gap-8 relative shrink-0 w-full max-w-[1633px]">
      {featureCards.map((card, index) => (
        <FeatureCard key={index} title={card.title} description={card.description} />
      ))}
    </div>
  );
}

function Frame73() {
  return (
    <div className="relative shrink-0 w-full">
      <div className="flex flex-col items-center justify-center size-full">
        <div className="box-border content-stretch flex flex-col items-center justify-center px-4 sm:px-6 md:px-12 lg:px-16 xl:px-16 py-0 relative w-full">
          <Frame71 />
        </div>
      </div>
    </div>
  );
}

function Frame91() {
  return (
    <div className="content-stretch flex flex-col gap-6 sm:gap-7 md:gap-8 lg:gap-10 xl:gap-12 items-center w-full py-8 sm:py-10 md:py-12 lg:py-16 xl:py-20">
      <Frame6 />
      <Frame73 />
    </div>
  );
}

export default function WhyChooseSection() {
  return (
    <div className="bg-[#3a599c] overflow-clip relative shrink-0 w-full">
      <Frame91 />
    </div>
  );
}

